// Compatibilidade de conteúdo: o ID antigo continua aceito, mas todo conteúdo
// novo da disciplina usa um único ID canônico.
export const MATERIA_PRINCIPAL = {
  legislacao_extravagante: 'legislacao_penal_especial'
};

export const normalizarMateriaId = (id) => MATERIA_PRINCIPAL[id] || id;

export const materiaNoEscopo = (materiaId, materias = []) => {
  const normalizada = normalizarMateriaId(materiaId);
  return materias.some(id => normalizarMateriaId(id) === normalizada);
};

